module.exports = __webpack_public_path__ + "img/nav-bg.ad87f36a.png";